let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3lwWF")).then(() => parcelRequire('bXu7U'));